/** Budget lug'ati (ru) */
export default {
  title: "Бюджет",
  subtitle: "{{scope}} · {{period}} · план и факт",
  month: "Месяц",
  editPlan: "Изменить план",
  tabs: { overview: "Обзор", money: "Деньги", expenses: "Расходы", salaries: "Зарплаты", bonuses: "Бонусы", placements: "Оплаты перевозчиков" },
  scope: { branch: "Филиал", all: "Все филиалы", yours: "Ваш филиал" },
  cat: { salaries: "Зарплаты", expenses: "Расходы", bonuses: "Бонусы" },
  total: "Итого",
  status: "Статус",
  conflict: "Изменено: {{who}}. Перезагружено.",
  someoneElse: "другой пользователь",
  plan: {
    saved: "План сохранён",
    saveFailed: "Не удалось сохранить план.",
    title: "План · {{period}}",
    desc: "Месячные лимиты по филиалам. Фактические расходы сравниваются с этими цифрами.",
    save: "Сохранить план",
    branch: "Филиал",
  },
  overview: {
    noPlan: "План на {{month}} не задан.",
    noPlanSub: "Фактические расходы показаны без лимитов.",
    noPlanOwner: "Чтобы задать лимиты, нажмите «Изменить план» выше.",
    noPlanManager: "План задаёт владелец.",
    planKpi: "План · {{month}}",
    planSub_one: "{{count}} филиал, 3 категории",
    planSub_few: "{{count}} филиала, 3 категории",
    planSub_many: "{{count}} филиалов, 3 категории",
    planSub_other: "{{count}} филиала, 3 категории",
    actual: "Факт",
    ofPlan: "{{pct}}% от плана",
    noPlanShort: "плана нет",
    costPerHire: "Стоимость найма",
    costSub_one: "{{count}} найм · зарплаты + расходы + бонусы",
    costSub_few: "{{count}} найма · зарплаты + расходы + бонусы",
    costSub_many: "{{count}} наймов · зарплаты + расходы + бонусы",
    costSub_other: "{{count}} найма · зарплаты + расходы + бонусы",
    over: "Превышение бюджета",
    overBranches_one: "{{count}} филиал",
    overBranches_few: "{{count}} филиала",
    overBranches_many: "{{count}} филиалов",
    overBranches_other: "{{count}} филиала",
    within: "Все филиалы в рамках плана",
    byCategory: "По категориям · {{month}}",
    pending: "в ожидании",
    draft: "черновик",
    alerts: "Предупреждения",
    noAlerts: "В этом месяце ничего не требует внимания.",
    details: "Подробнее →",
    review: "Открыть →",
    branches: "Филиалы · {{month}}",
    branchesSub: "План и факт по филиалам. Стоимость найма = все расходы ÷ подтверждённые наймы.",
    of: "из {{plan}} · {{pct}}%",
    noPlanBar: "· плана нет",
    extra: "+ {{amount}} {{label}}",
    cols: { branch: "Филиал", plan: "План", actual: "Факт", used: "Использовано", salaries: "Зарплаты", expenses: "Расходы", bonuses: "Бонусы", hires: "Наймы", costPerHire: "Стоимость / найм" },
  },
  expenses: {
    archived: "Расход архивирован",
    archiveFailed: "Не удалось архивировать расход.",
    add: "+ Добавить расход",
    categoryAll: "Категория: все",
    statusAll: "Статус: все",
    category: "Категория",
    searchPlaceholder: "Поиск по описанию",
    searchAria: "Поиск расходов",
    emptyFiltered: "Нет расходов по этим фильтрам",
    emptyMonth: "Нет расходов за {{month}}",
    emptyDesc: "Расходы, внесённые менеджером филиала, отправляются владельцу на подтверждение.",
    cols: { date: "Дата", category: "Категория", description: "Описание", branch: "Филиал", amount: "Сумма", submittedBy: "Внёс", receipt: "Чек", status: "Статус", actions: "Причина / действия" },
    receipt: "Чек",
    reason: "Причина: {{reason}}",
    notSpecified: "не указана",
    by: "{{name}}",
    totalLabel: "Итого (подтверждённые + в ожидании):",
    rejectedSum: " · отклонено {{amount}}",
    paginationLabel: "расходов",
    archiveTitle: "Архивировать расход?",
    archiveBody: "Ничего не удаляется: расход скрывается из списков и остаётся в журнале аудита.",
    archiveBodyRequest: " Его запрос на подтверждение остаётся как есть.",
    summary: { plan: "План на {{month}}: {{plan}}", notSet: "не задан", spent: "· Потрачено {{amount}}", waiting: "Ждут подтверждения · {{amount}}" },
    modal: {
      tooLarge: "Файл больше {{mb}} МБ.",
      dateRequired: "Укажите дату.",
      chooseCategory: "Выберите категорию.",
      positiveAmount: "Введите положительную сумму.",
      chooseBranch: "Выберите филиал.",
      receiptRequired: "Нужен чек.",
      updated: "Расход обновлён",
      submitted: "Отправлено на подтверждение",
      submittedSub: "Владелец увидит его в разделе «Подтверждения».",
      added: "Расход добавлен",
      saveFailed: "Не удалось сохранить расход.",
      editTitle: "Изменить расход",
      addTitle: "Добавить расход",
      submit: "Отправить на подтверждение",
      date: "Дата", category: "Категория", amount: "Сумма", currency: "Валюта", branch: "Филиал", description: "Описание", receipt: "Чек",
      choose: "Выберите…",
      noConversion: "Показывается как введено; без конвертации",
      descPlaceholder: "Реклама Facebook: лиды водителей (1–6 окт)",
      keepReceipt: "Оставьте пустым, чтобы сохранить текущий чек.",
      dropHere: "Перетащите чек сюда или",
      browse: "выберите файл",
      fileTypes: "JPG, PNG или PDF, до {{mb}} МБ",
      removeFile: "Убрать файл",
      current: "Текущий: {{name}}",
      goesToOwner: "Расход отправляется владельцу на подтверждение. До этого он показывается как «В ожидании».",
    },
  },
  salaries: {
    saved: "Зарплаты сохранены",
    savedSub_one: "{{count}} строка · {{month}}",
    savedSub_few: "{{count}} строки · {{month}}",
    savedSub_many: "{{count}} строк · {{month}}",
    savedSub_other: "{{count}} строки · {{month}}",
    saveFailed: "Не удалось сохранить зарплаты.",
    markedPaid: "Отмечено как выплачено · {{name}}",
    markedUnpaid: "Отмечено как не выплачено · {{name}}",
    updateFailed: "Не удалось обновить.",
    markedCount: "Отмечено как выплачено: {{count}}",
    subtitle: "{{scope}} · зарплаты · {{month}}",
    markSelected: "Отметить выбранные как выплаченные",
    roleAll: "Роль: все",
    role: "Роль",
    paid: "Выплачено",
    paidAll: "Выплата: все",
    notPaid: "Не выплачено",
    visibility: "Видно только владельцу и менеджеру вашего филиала",
    empty: "Нет сотрудников по этим фильтрам",
    cols: { employee: "Сотрудник", role: "Роль", branch: "Филиал", amount: "Месячная зарплата", paid: "Выплачено", paidDate: "Дата выплаты", note: "Примечание" },
    selectAllUnpaid: "Выбрать все невыплаченные",
    select: "Выбрать {{name}}",
    lastMonth: "{{amount}} (прошлый месяц)",
    salaryAria: "Зарплата: {{name}}",
    enterFirst: "Сначала введите и сохраните сумму",
    ownerSets: "Эту зарплату устанавливает владелец",
    ownerOnlyUnpaid: "Снять отметку о выплате может только владелец",
    bankTransfer: "Банковский перевод",
    totalRow_one: "Итого · {{count}} сотрудник · выплачено {{paid}} / {{count}}",
    totalRow_few: "Итого · {{count}} сотрудника · выплачено {{paid}} / {{count}}",
    totalRow_many: "Итого · {{count}} сотрудников · выплачено {{paid}} / {{count}}",
    totalRow_other: "Итого · {{count}} сотрудника · выплачено {{paid}} / {{count}}",
    note: "Система только фиксирует сумму; деньги выплачиваются через банк. Выплаченные строки заблокированы.",
    unsaved_one: "{{count}} несохранённое изменение",
    unsaved_few: "{{count}} несохранённых изменения",
    unsaved_many: "{{count}} несохранённых изменений",
    unsaved_other: "{{count}} несохранённых изменения",
    discard: "Отменить",
    save: "Сохранить зарплаты",
  },
  bonuses: {
    supplement: "Доплата",
    calculated: "Рассчитано за {{month}}",
    calculatedSub: "{{count}} рекрутеров · утверждённые и оплаченные бонусы не изменены",
    calculatedExtra: "Доплаты: {{count}} (наймы, утверждённые позже)",
    calcFailed: "Не удалось рассчитать.",
    approved_one: "Подтверждён {{count}} бонус",
    approved_few: "Подтверждено {{count}} бонуса",
    approved_many: "Подтверждено {{count}} бонусов",
    approved_other: "Подтверждено {{count}} бонуса",
    approvedSub: "Рекрутеры уведомлены.",
    approveFailed: "Не удалось подтвердить.",
    markedCount: "Отмечено как выплачено: {{count}}",
    updateFailed: "Не удалось обновить.",
    subtitle: "{{scope}} · бонусы рекрутеров · {{month}}",
    markPaid: "Отметить выплаченными ({{count}})",
    calculate: "Рассчитать за {{month}}",
    approveAll: "Подтвердить все ({{count}})",
    rule: "Правило: {{name}}",
    ruleBase: "· {{perHire}} за найм + {{per30}} за каждого, кто проработал 30 дней",
    rule60: " + {{amount}} за 60 дней",
    rule90: " + {{amount}} за 90 дней",
    editInAdmin: "Изменить в Админ → Настройки",
    statusAll: "Статус: все",
    withBonusOnly: "Только с бонусом",
    summary: "{{count}} рекрутеров · {{draft}} черновик · {{approved}} подтверждено · {{paid}} выплачено",
    emptyMonth: "Бонусы за {{month}} не рассчитаны",
    emptyDesc: "Бонусы рассчитываются по подтверждённым наймам и проверкам удержания из истории статусов.",
    emptyFiltered: "Нет бонусов по этим фильтрам",
    cols: { recruiter: "Рекрутер", hires: "Наймы", stayed: "Остались 30 / 60 / 90 д", rule: "Правило", calculated: "Рассчитано", adjustment: "Корректировка", total: "Итого", status: "Статус" },
    selectApproved: "Выбрать подтверждённые",
    select: "Выбрать {{name}}",
    totalRow_one: "Итого · {{count}} рекрутер",
    totalRow_few: "Итого · {{count}} рекрутера",
    totalRow_many: "Итого · {{count}} рекрутеров",
    totalRow_other: "Итого · {{count}} рекрутера",
    approveTitle_one: "Подтвердить {{count}} бонус · {{month}}",
    approveTitle_few: "Подтвердить {{count}} бонуса · {{month}}",
    approveTitle_many: "Подтвердить {{count}} бонусов · {{month}}",
    approveTitle_other: "Подтвердить {{count}} бонуса · {{month}}",
    approveDesc: "Подтверждённые бонусы окончательны: они учитываются в бюджете, а рекрутеры видят сумму на своём дашборде.",
    approveSum: "Подтвердить {{sum}}",
    hiresShort: "· наймов: {{count}}",
    adjSaved: "Корректировка сохранена · {{name}}",
    saveFailed: "Не удалось сохранить.",
    adjustment: "Корректировка",
    adjustmentNote: "Примечание к корректировке",
    notePlaceholder: "Примечание",
    hide: "Скрыть",
    details: "Подробнее",
    d: {
      hiresIn: "Наймы за {{month}} · {{count}} × {{per}} = {{sum}}",
      hiredOn: "• {{driver}} · нанят {{date}}",
      start: " · начал {{date}}",
      noHires: "Подтверждённых наймов нет",
      stayed30: "Проработали 30 дней · {{count}} × {{per}} = {{sum}}",
      d60: " · 60 д",
      d90: " · 90 д",
      noneYet: "Пока никого",
      result: "Результат",
      calculated: "• Рассчитано: {{amount}}",
      adjustment: "• Корректировка: {{amount}}",
      total: "• Итого: {{amount}}",
      status: "• Статус: {{status}}",
      by: " · {{name}}",
      paid: " · выплачено {{date}}",
    },
  },
  placements: {
    subtitle: "{{scope}} · деньги, которые перевозчики платят за нанятых водителей",
    rule: "Срок: через {{days}} дней после выхода водителя (Настройки)",
    status: "Статус оплаты",
    search: "Поиск водителя или перевозчика",
    unit: "размещений",
    empty: "Ничего нет",
    emptyDesc: "Размещения появляются, когда водителя нанимают.",
    state: { all: "Все статусы", open: "Открытые: ожидаются и просрочены", overdue: "Просрочено", due: "Ожидается (срок не наступил)", paid: "Оплачено", partial: "Оплачено частично", not_paid: "Не оплачено" },
    kpi: {
      overdue: "Просрочено", overdueSub: "срок прошёл, не оплачено",
      due: "Ожидается", dueSub: "срок ещё не наступил", expected: "ожидается {{amount}}",
      paid: "Оплачено", partial_one: "{{count}} частично", partial_few: "{{count}} частично", partial_many: "{{count}} частично", partial_other: "{{count}} частично",
      notPaid: "Не оплачено",
      approvalPending: "Ждёт одобрения", approvalPendingSub: "найм ещё не одобрен",
    },
    cols: { driver: "Водитель", recruiter: "Рекрутер", branch: "Филиал", carrier: "Перевозчик", started: "Вышел", due: "Срок", amount: "Сумма", status: "Статус", note: "Примечание" },
    modalTitle: "Оплата перевозчика",
    started: "вышел {{date}}",
    dueOn: "срок {{date}}",
    amount: "Сумма ($)",
    amountHint: "Оставьте пустым, если неизвестно",
    paidOn: "Дата оплаты",
    note: "Примечание",
    notePlaceholder: "например: замена другому водителю",
    filters: { carrier: "Все перевозчики", recruiter: "Все рекрутеры", approval: "Одобрение найма: любое", approvalYes: "Найм одобрен", approvalNo: "Ждёт одобрения", period: "Месяц выхода: любой" },
    emptyFiltered: "Под эти фильтры ничего не подходит.",
    addPayment: "Оплата",
    recordPayment: "Записать оплату",
    receivedLine: "получено {{received}}",
    remainingLine: "осталось {{remaining}}",
    legacy: "статус из импорта · поступление не записано",
    remainingBox: "Получено {{received}} из {{total}} · осталось {{remaining}}",
    paymentTitle: "Поступили деньги от перевозчика",
    paymentAmount: "Полученная сумма ($)",
    paymentAmountRequired: "Введите сумму.",
    paymentAccountRequired: "Выберите счёт, на который пришли деньги.",
    paymentDate: "Дата",
    paymentTime: "Время",
    paymentNotePlaceholder: "например: номер перевода",
    paymentSaved: "{{amount}} записано · {{name}}",
    convertedHint: "Счёт в {{currency}}: пересчёт по курсу дня оплаты.",
    editTitle: "Условия оплаты",
    dueDate: "Срок",
    editReceivedNote: "Уже получено {{received}}: статус считается по поступлениям.",
    writeOffTitle: "Отметить {{name}} как неоплаченное?",
    writeOffDesc: "Когда перевозчик не заплатит. Позже можно открыть снова.",
    writeOff: "Отметить неоплату",
    reopen: "Открыть снова",
    voidTitle: "Отменить эту оплату?",
    voidDesc: "{{amount}} → {{account}} убирается из журнала (остаётся в аудите); статус пересчитывается.",
    void: "Отменить оплату",
    voided: "Оплата отменена · {{name}}",
    saved: "Оплата сохранена · {{name}}",
  },
  money: {
    income: "Приход",
    expense: "Расход",
    transfer: "Перевод",
    totalBalance: "Деньги на счетах",
    totalHint: "Все счета в USD по сегодняшнему курсу",
    inCurrency: "В {{currency}}",
    rate: "Курс валют",
    rateValue: "1 USD = {{rate}} UZS",
    noRate: "Курса пока нет",
    rateCbu: "Центробанк · {{date}}",
    rateManual: "Указан вручную · {{date}}",
    rateTitle: "Курс USD/UZS",
    rateDesc: "Курс Центробанка загружается автоматически каждый день. Курс, указанный вручную на день, не перезаписывается.",
    rateSaved: "Курс сохранён",
    company: "Компания",
    newAccount: "Открыть счёт",
    archived: {
      link: "Архивные счета ({{count}})",
      title: "Архивные счета",
      desc: "Их нет в списке и в итогах. Восстановите счёт, чтобы снова им пользоваться или отменить оплату с него.",
      restore: "Восстановить",
      restored: "{{name}} снова в списке",
    },
    editAccount: "Изменить счёт",
    accountDesc: "Наличная касса, карта или банковский счёт. От карты хранятся только последние 4 цифры.",
    accountCreated: "Счёт открыт · {{name}}",
    accountSaved: "Счёт сохранён",
    deleteTitle: "Удалить {{name}}?",
    deleteDesc: "Остаток: {{balance}}. Счёт исчезнет из списка и из итогов; его записи останутся в журнале и в аудите, связанные платежи останутся оплаченными.",
    deleted: "Удалён · {{name}}",
    reconcileTitle: "Сверка остатка: {{name}}",
    reconcileDesc: "Введите фактический остаток на карте или в кассе. Разница запишется одной корректировкой; история не меняется.",
    reconcileIn: "Будет записано поступление (корректировка) {{amount}}",
    reconcileOut: "Будет записано списание (корректировка) {{amount}}",
    reconcileSame: "Остаток уже совпадает.",
    reconciled: "{{account}}: сверено с {{amount}}",
    noAccountsTitle: "Счетов пока нет",
    noAccountsManager: "Счета открывает владелец и может привязать их к вашему филиалу.",
    filterByAccount: "Показать движения этого счёта",
    accountKinds: { cash: "Наличные", card: "Карта", bank: "Банковский счёт" },
    kinds: { fee: "Оплата перевозчика", income: "Приход", expense: "Расход", salary: "Зарплата", bonus: "Бонус", transfer: "Перевод", adjustment: "Корректировка" },
    flow: { all: "Все", in: "Приход", out: "Расход", transfer: "Переводы" },
    ledger: "Приход и расход · {{month}}",
    ledgerSub: "Каждое движение денег по счетам. Изменить или отменить — правой кнопкой по строке.",
    ledgerFor: "Счёт: {{account}}",
    allAccounts: "Все счета",
    searchPh: "Описание или от кого/кому",
    movements: "движений",
    emptyTitle: "В этом месяце движений нет",
    emptyDesc: "Записывайте приход, расход и переводы кнопками выше. Оплаченные зарплаты, бонусы и расходы попадают сюда сами.",
    emptyNoAccounts: "Сначала откройте счёт.",
    toAcc: "на {{account}}",
    fromAcc: "с {{account}}",
    col: { date: "Дата", what: "Что", account: "Счёт", type: "Тип", amount: "Сумма", usd: "В USD", balance: "Остаток" },
    moveTitle: { income: "Приход", expense: "Расход", adjustment: "Исправить остаток" },
    moveDesc: {
      income: "Поступление, кроме оплаты перевозчика: инвестиция, возврат и т. п. Оплаты перевозчиков — в разделе «Оплаты перевозчиков».",
      expense: "Записывается как одобренный расход и оплачивается со счёта за один шаг.",
      adjustment: "Только если реальный остаток отличается от показанного (например, после пересчёта кассы).",
    },
    saved: {
      income: "{{amount}} поступило на {{account}}",
      expense: "{{amount}} оплачено с {{account}}",
      adjustment: "Остаток {{account}} исправлен",
    },
    editMove: "Изменить движение",
    editLinkedHint: "Сумму и дату связанного платежа изменить нельзя: отмените и запишите заново.",
    transferTitle: "Перевод между счетами",
    transferDesc: "Например, наличные на карту или USD в UZS. Записываются обе стороны.",
    transferDo: "Перевести",
    transferred: "Переведено: {{from}} → {{to}}",
    voidTitle: "Отменить это движение?",
    voidDesc: "{{amount}} на {{account}} больше не будет учитываться в остатке.",
    voidLinked: "Зарплата или бонус снова станет неоплаченной.",
    voidTransfer: "Отменяются обе стороны перевода.",
    voided: "Движение отменено",
    menu: {
      income: "Приход",
      expense: "Расход",
      transfer: "Перевод",
      edit: "Изменить счёт",
      reconcile: "Сверить остаток",
      delete: "Удалить",
      openLinked: "Открыть запись",
      openDriver: "Открыть водителя",
      editMove: "Изменить",
      void: "Отменить движение",
    },
    f: {
      name: "Название",
      namePh: "Например: Касса офиса, Kapitalbank Humo",
      kind: "Тип",
      currency: "Валюта",
      currencyLocked: "Нельзя изменить после движений",
      bank: "Банк / карта",
      bankPh: "Например: Kapitalbank Humo",
      last4: "Карта: последние 4 цифры",
      last4Hint: "Полный номер никогда не хранится",
      branch: "Филиал",
      branchHint: "Если выбран филиал, его менеджер тоже видит и ведёт этот счёт. Без филиала — только владелец.",
      company: "Компания (только владелец)",
      opening: "Начальный остаток, {{currency}}",
      openingDate: "Остаток на дату",
      note: "Примечание",
      account: "Счёт",
      direction: "Направление",
      adjIn: "Добавить к остатку",
      adjOut: "Вычесть из остатка",
      ledgerBalance: "Остаток по журналу",
      actualBalance: "Фактический остаток, {{currency}}",
      amount: "Сумма, {{currency}}",
      date: "Дата",
      time: "Время",
      category: "Категория",
      chooseCategory: "Выберите категорию",
      noCategory: "Без категории",
      branchFromAccount: "По умолчанию: {{branch}} (филиал счёта)",
      noBranch: "Без филиала",
      counterparty: "От кого",
      counterpartyPh: "Например: владелец, возврат от поставщика",
      description: "Описание",
      from: "Откуда",
      to: "Куда",
      received: "Поступило, {{currency}}",
      receivedHint: "Подсказка по курсу 1 USD = {{rate}} UZS; измените, если курс банка другой",
      rate: "1 USD в UZS",
    },
  },
  commission: {
    label: "Комиссия, %",
    hint: "Необязательно. Берётся из категории; пусто или 0 — без комиссии.",
    invalid: "Введите от 0 до 99,99.",
    resultIn: "Комиссия {{fee}} · на счёт поступит {{net}}",
    resultOut: "Комиссия {{fee}} · со счёта спишется {{net}}",
    rowIn: "{{base}} − {{pct}}% комиссия",
    rowOut: "{{base}} + {{pct}}% комиссия",
  },
  pay: {
    paying: "К оплате:",
    receiving: "Поступает:",
    fromAccount: "С какого счёта",
    toAccount: "На какой счёт поступило",
    choose: "Выберите счёт",
    noAccounts: "Счетов пока нет: владелец открывает их в разделе Бюджет → Деньги.",
    noAccount: "Без счёта (только отметить оплату)",
    noAccountHint: "Деньги не учитываются в остатке какого-либо счёта.",
    date: "Дата",
    time: "Время",
    converted: "Со счёта: {{amount}} (1 USD = {{rate}} UZS; точная сумма — по курсу дня оплаты)",
    noRate: "Курса USD/UZS пока нет.",
    balanceAfter: "Остаток: {{before}} → {{after}}",
    insufficient: "Недостаточно средств: на этом счёте не хватает {{short}}.",
    markPaid: "Отметить оплату",
    pay: "Оплатить",
    salaryTitle_one: "Выплатить {{count}} зарплату",
    salaryTitle_few: "Выплатить {{count}} зарплаты",
    salaryTitle_many: "Выплатить {{count}} зарплат",
    salaryTitle_other: "Выплатить {{count}} зарплаты",
    bonusTitle_one: "Выплатить {{count}} бонус",
    bonusTitle_few: "Выплатить {{count}} бонуса",
    bonusTitle_many: "Выплатить {{count}} бонусов",
    bonusTitle_other: "Выплатить {{count}} бонуса",
    expenseTitle: "Оплатить расход",
    expensePaid: "Расход оплачен",
    payExpense: "Оплатить",
    paidFrom: "Оплачено · {{account}}",
    feeAccountHint: "Выберите счёт, на который пришли деньги, — они появятся в его остатке",
    receivedNow: "Поступило сейчас, USD",
    receivedHint: "Пусто: полная сумма платежа",
  },
  cash: {
    onAccounts: "Деньги на счетах",
    noAccounts: "Откройте счета в разделе «Деньги»",
    in: "Приход · {{month}}",
    out: "Расход · {{month}}",
    net: "Итог · {{month}}",
    netSub: "Приход минус расход (без переводов)",
    vsPrev: "{{pct}}% к прошлому месяцу",
    noPrev: "в прошлом месяце нет",
    missingRate: "Для части сумм в UZS курса пока нет",
    chartTitle: "Приход и расход · 12 месяцев",
    chartSub: "Все счета, в USD. Переводы между счетами не учитываются.",
    chartEmpty: "Движений денег пока нет. Откройте счета в разделе Бюджет → Деньги.",
    series: { in: "Приход", out: "Расход", net: "Итог" },
    spendTitle: "Куда ушли деньги · {{month}}",
    spendEmpty: "В этом месяце расходов нет.",
    other: "Другое",
    dueTitle: "К оплате и к получению",
    nothingDue: "Всё одобренное оплачено.",
    due: {
      expenses_one: "{{count}} одобренный расход",
      expenses_few: "{{count}} одобренных расхода",
      expenses_many: "{{count}} одобренных расходов",
      expenses_other: "{{count}} одобренных расхода",
      salaries_one: "{{count}} неоплаченная зарплата",
      salaries_few: "{{count}} неоплаченные зарплаты",
      salaries_many: "{{count}} неоплаченных зарплат",
      salaries_other: "{{count}} неоплаченной зарплаты",
      bonuses_one: "{{count}} одобренный бонус",
      bonuses_few: "{{count}} одобренных бонуса",
      bonuses_many: "{{count}} одобренных бонусов",
      bonuses_other: "{{count}} одобренных бонуса",
    },
    pay: "Оплатить",
    open: "Открыть",
    payable: "Мы должны",
    receivable: "Нам должны",
    feesExpected_one: "Ожидается {{count}} оплата перевозчика",
    feesExpected_few: "Ожидается {{count}} оплаты перевозчиков",
    feesExpected_many: "Ожидается {{count}} оплат перевозчиков",
    feesExpected_other: "Ожидается {{count}} оплаты перевозчиков",
    feesOverdue_one: "{{count}} просрочена",
    feesOverdue_few: "{{count}} просрочены",
    feesOverdue_many: "{{count}} просрочено",
    feesOverdue_other: "{{count}} просрочено",
    feesNoAmount_one: "{{count}} без суммы",
    feesNoAmount_few: "{{count}} без суммы",
    feesNoAmount_many: "{{count}} без суммы",
    feesNoAmount_other: "{{count}} без суммы",
  },
};
